import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M14 7v3h3l3 -3h-3v-3l-3 3","key":"svg-0"}],["path",{"d":"M14 10l-9 9","key":"svg-1"}],["path",{"d":"M5 15v4h4","key":"svg-2"}]]

/**
 * IconArcheryArrow
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItYXJjaGVyeS1hcnJvdyIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNMTQgN3YzaDNsMyAtM2gtM3YtM2wtMyAzIiAvPgogIDxwYXRoIGQ9Ik0xNCAxMGwtOSA5IiAvPgogIDxwYXRoIGQ9Ik01IDE1djRoNCIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/archery-arrow
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconArcheryArrow = createReactComponent('outline', 'archery-arrow', 'ArcheryArrow', __iconNode);

export default IconArcheryArrow;